module.exports = __webpack_public_path__ + "static/media/muscle-wiki.1e168c5b.png";